


const Settings = () => {
  return (
    <div>Ayarlar</div>
  )
}

export default Settings